import enUS from "./__generated__/compiled/en-us.json";

export const messagesByLocale = {
  en: enUS,
  "en-US": enUS,
};
